import {ClaimTypes, ClaimServices, TicketType} from "../types/travelClaims";
import Plane from "../assets/plane_grey.svg";
import Train from "../assets/train_grey.svg";
import Bus from "../assets/bus_grey.svg";
import Cross from "../assets/cross.svg";
import Mountains from "../assets/mountains.svg";
export const getClaimTypeNameShort = (status: ClaimTypes) => {
    switch (status) {
        case 'SIMPLE':
            return 'Простая';
        case 'COMPLEX':
            return 'Сложная';
        case 'VISE':
            return 'Виза';
        default:
            return 'Неизвестно';
    }
}

export const getClaimTypeName = (type:ClaimTypes)=>{
    switch (type) {
        case 'SIMPLE':
            return 'Простая командировка';
        case 'COMPLEX':
            return 'Сложная командировка';
        case 'VISE':
            return 'Виза'
        default:
            return 'Неизвестный тип командировки';
    }
}

export const getClaimServiceName = (service: ClaimServices)=>{
    switch (service) {
        case 'MELON_BUSINESS_TRAVEL_CLIENT':
            return 'Melon Business Travel';
        case 'OUTLOOK':
            return 'Outlook';
        case 'TRIVIO':
            return 'Trivio'
        default:
            return 'Неизвестный сервис';
    }
}

export const getTicketTypeName = (type: TicketType)=>{
    switch (type) {
        case 'AVIA':
            return 'Авиа';
        case 'TRAIN':
            return 'Ж/Д';
        case 'BUS':
            return 'Автобус'
        case 'ANY':
            return 'Любой'
        default:
            return 'Любой'; // Ранее "Неизвестный тип", возможно баг на бэке
    }
}

export const getTicketTypeIcon = (type: TicketType)=>{
    switch (type) {
        case 'AVIA':
            return Plane;
        case 'TRAIN':
            return Train;
        case 'BUS':
            return Bus
        case 'ANY':
            return Mountains
        default:
            return Cross;
    }
}